import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@mui/styles';

import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

import ReactSelect from 'react-select';
import ReactCreatableSelect from 'react-select/creatable';
import { Tooltip } from '@mui/material';


class OutlinedSelect extends React.PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			menuIsOpen: false,
			mouseIsOver: false,
		};

		const theme = this.props.theme;
		const text = theme.palette.text;
		const primary = theme.palette.primary;
		const secondary = theme.palette.secondary;
		const background = theme.palette.background;
		const typography = theme.typography;
		const font = typography.subheading;

		this.selectStyles = {
			control: (provided, state) => {
				return ({
					...provided,
					...font,
					background: 'transparent',
					borderColor: state.menuIsOpen || state.isHovered ? primary.main : theme.palette.border.normal,
					borderWidth: state.menuIsOpen ? 2 : 1,
					height: 36,
					minHeight: 36,
					boxShadow: 'none',
					'&:hover': {
						borderColor: state.menuIsOpen ? primary.main : text.primary,
					}
				});
			},
			container: (provided, state) => ({
				...provided,
				color: state.isFocused ? theme.palette.action.hover : theme.palette.action.disabled,
			}),
			dropdownIndicator: (provided, state) => ({
				...provided,
				color: theme.palette.action.disabled,
				'&:hover': {
					color: text.primary,
				}
			}),
			indicatorSeparator: (provided, state) => ({
				...provided,
				backgroundColor: theme.palette.action.disabled,
			}),
			input: (provided, state) => ({
				...provided,
				color: text.primary,
				// borderColor: state.menuIsOpen ? primary.main : state.isFocused ? theme.palette.action.hover : theme.palette.action.disabled,
			}),
			singleValue: (provided, state) => ({
				...provided,
				color: text.primary,
				// borderColor: state.menuIsOpen ? primary.main : state.isFocused ? theme.palette.action.hover : theme.palette.action.disabled,
			}),
			placeholder: (provided, state) => ({
				...provided,
				color: text.secondary,
			}),
			menu: (provided, state) => ({
				...provided,
				background: background.scrollMenu,
				color: text,
				boxShadow: '0 6px 12px rgba(0,0,0,.175)',
				marginTop: 0,
				marginBottom: 0,
			}),
			option: (provided, state) => {
				let fontStyle = state.value === '' ? 'italic' : 'normal'; // '' === None
				return {
					...provided,
					fontStyle: fontStyle,
					color: state.isSelected ? primary.main : text.primary,
					background: state.isFocused ? background.rowHover : (state.isSelected ? background.default : 'transparent'),
					'&:active': {
						backgroundColor: background.rowActive,
						color: secondary.main,
					}
				};
			},
		};

		this.labelStyle = {
			fontSize: '12px',
			marginLeft: 8,
			padding: '0 4px',
			background: background.paper,
			transform: 'translateY(0.5em)',
			zIndex: 1,
			display: 'inline-table',
			width: 'max-content',
		};
	}

	render() {
		let options = [];
		let required = this.props.required || false;
		if (this.props.items !== null) {
			options = this.props.items.map(item => { return { value: item, label: item !== null ? item.toString() : 'null' }; });
		}
		if (!required && this.props.withNone) {
			options = [{ value: '', label: 'None' }, ...options];
		}
		let props = {
			name: this.props.name,
			value: this.props.value !== '' ? options.find(({ value }) => this.props.value === value) : null,
			onChange: (option) => {
				this.setState({ mouseIsOver: false });
				this.props.onChange(option.value);
			},
			onMenuOpen: () => this.setState({ menuIsOpen: true }),
			onMenuClose: () => this.setState({ menuIsOpen: false }),
			options: options,
			isSearchable: true,

			menuPortalTarget: document.querySelector('body'), // fix for hidden dropdown
			fullWidth: true,
			styles: this.selectStyles,
			menuPlacement: 'auto',
		};
		let mouseProps = {
			onMouseEnter: () => this.setState({ mouseIsOver: true }),
			onMouseLeave: () => this.setState({ mouseIsOver: false }),
		};
		const select = this.props.creatable === true ?
			(<ReactCreatableSelect
				{...props}
				formatCreateLabel={value => value.toString()}
				isValidNewOption={this.props.isValidNewOption}
			/>) :
			(<ReactSelect
				{...props}
			/>);
		let helperText = this.props.descr;
		return (
			<FormControl fullWidth>
				<FormLabel style={this.labelStyle} required={required}>
					{this.props.name}
				</FormLabel>
				<Tooltip open={this.state.mouseIsOver && !this.state.menuIsOpen} title={helperText && <div style={{ whiteSpace: 'pre-line' }} dangerouslySetInnerHTML={{ __html: helperText }} />}>
					<div {...mouseProps}>
						{select}
					</div>
				</Tooltip>
				{helperText && <FormHelperText>{new DOMParser().parseFromString(helperText, 'text/html').body.textContent || ''}</FormHelperText>}
			</FormControl>
		);
	}
}

OutlinedSelect.propTypes = {
	name: PropTypes.string,
	descr: PropTypes.string,
	value: PropTypes.any,
	required: PropTypes.bool,
	withNone: PropTypes.bool,

	items: PropTypes.array,

	onChange: PropTypes.func,

	creatable: PropTypes.bool,
	isValidNewOption: PropTypes.func,

	theme: PropTypes.object,
};

export default withTheme(OutlinedSelect);
